<template>
    <v-row>
        <v-col cols="12" md="6">
            <div style="position: sticky; top: 0; overflow: hidden">
                <h5 class="page-text--lg font-weight-medium mb-10">날짜 선택 후 시간을 선택해주세요.</h5>
                <v-card rounded="lg" outlined>
                    <div class="pa-20 pa-md-30 pa-lg-40">
                        <date-picker v-model="date" v-bind="{ events }"/>
                    </div>
                </v-card> 
            </div>               
        </v-col>
        <v-col cols="12" md="6">
            <listed-time-picker v-model="selected" v-bind="{ date, multiple }" @input="emit" />
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "dayjs";
import DatePicker from "./date-picker.vue";
import ListedTimePicker from "./listed-time-picker.vue";

export default {
    components: {
        ListedTimePicker,
        DatePicker,
    },
    props: {
        value: { type: [Array, String], default: () => [] },

        multiple: { type: Boolean, default: false },

        timeStarts: { type: String, default: "9:00" },
        timeEnds: { type: String, default: "21:00" },
        timeSpan: { type: String, default: "0:30" },
    },

    data: () => ({
        date: Date.now().toDate(),
        selected: [],
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.selected = [...this.value];
        },
        emit() {
            this.$emit("input", this.selected);
        },
        events(date) {
            return this.value.some((item) => dayjs(item).isSame(date, "date"));
        },
    },
};
</script>
